"use client"

import React, { useRef } from 'react'
import { motion, useInView } from "framer-motion";
import Link from "next/link";

function ReportsPage({ blok }) {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  return (
    <div className=' w-full'>
      <div className='bg-asmPageTopBG' style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundPosition: "bottom", // Center the background image
        backgroundRepeat: "repeat", // Prevent repeating the background
        // maxWidth: 1920,
        // margin: 'auto'
      }}>
        <div className='max-w-[1920px] m-auto'>
          <div className="relative lg:min-h-[1000px] lg:flex flex-col items-center py-8 max-w-[1920px] m-auto">

            <div className="font-aileron py-20 lg:py-32 text-center font-bold">
              <h1 className="bg-custom-radial bg-clip-text text-transparent text-[38px] lg:text-[80px]">
                {blok.titleText1}
              </h1>
              <div className="font-lato mt-4 text-[20px] w-[80%] lg:w-[80%] m-auto lg:text-[32px] font-normal ">
                {blok.titleText2}
              </div>
            </div>
            <div className="p-4 lg:p-0 space-y-10 lg:space-y-[40px] -mt-20">
              <div className="flex flex-col items-center text-center justify-center w-full m-auto py-14">
                <motion.div
                  ref={ref1}
                  initial={{ opacity: 0, x: -100 }}
                  animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="w-full px-4 max-w-[1200px]"
                >
                  {blok.Reports.map((item, index) => (
                    <div
                      key={index}
                      className="w-full bg-white shadow-lg rounded-lg flex flex-col lg:flex-row items-center lg:items-center text-center lg:text-left p-6 sm:p-10 gap-6 mb-10"
                    >
                      <img src={item.image?.filename} className="w-full lg:w-[40%] lg:h-[327px] object-contain" />
                      <div className="flex flex-col items-center lg:items-start justify-start w-full">
                        <p className="font-lato text-[16px] lg:text-[24px] text-[#49378F] font-bold mb-2">
                          {item.title}
                        </p>
                        <p className="text-[14px] lg:text-[18px] font-lato">{item.description}</p>
                        <Link href={"/" + item.url?.cached_url}>
                          <button className="mt-6 bg-[#E56717] text-white py-2 px-4 rounded hover:bg-orange-600 transition w-full font-lato text-[14px]">
                            {item.ctaText}
                          </button>
                        </Link>
                      </div>
                    </div>
                  ))}
                </motion.div>
              </div>
            </div>


          </div>
        </div>
      </div>
      {/* <Footer blok={blok} /> */}
    </div>
  )
}

export default ReportsPage